var Autocomplete = function(container, options) {
    var _this = this;
    _this.container = $(container);

    _this.initializeOptions(options);
    _this.initializeEvents(options);
    _this.initializeComponent();
}

Autocomplete.prototype = {
    constructor: Autocomplete,
    initializeOptions: function(opt) {
        if (opt == null) {
            opt = [];
        }

        this.options = {
            name: opt.name,
            value: opt.value,
            url: opt.url
        };
    },
    initializeEvents: function(opt) {
        if(opt == null) {
            opt = [];
        }
    
        if(opt.onEnter) { this.element.bind('onEnter', opt.onEnter); }
        if(opt.onSelectItem) { this.element.bind('onSelectItem', opt.onSelectItem); }
    },
    initializeComponent() {
        var _this = this;

        _this.container.addClass('autocomplete');

        _this.icon = $('<img />').addClass('autocomplete-icon').attr('src', '/img/icons/search.svg');
        _this.container.append(_this.icon);
        _this.icon.click(function(e) {
            if(_this.container.is('.focus')) {
                // Avoid propagating to the container, which will put the focus on the autocomplete
                e.preventDefault();
                e.stopPropagation();

                // Remove the focus from the autocomplete
                _this.input.blur();
                _this.triggerEvent('onEnter', { value: _this.input.val() });
            }
        });

        _this.input = $('<input/>').addClass('autocomplete-input')
            .attr('placeholder', 'Search for...')
            .attr('autocomplete', 'off')
            .attr('name', _this.options.name).val(_this.options.value);

        _this.container.append(_this.input);
            
        _this.results = $('<div/>').addClass('autocomplete-results');
        _this.container.append(_this.results);

        _this.input.keyup(function(e) {
            if (e.which == 13) {
                _this.input.blur();
                _this.triggerEvent('onEnter', { value: _this.input.val() });
            }
            else {
                if (_this.input.val().length == 0) {
                    _this.results.empty();
                    return;
                }

                // Load autocomplete results
                 $.ajax({
                    method: "GET",
                    url: _this.options.url + "?search_term=" + _this.input.val(),
                    success: function(results) {
                        _this.results.empty();

                        if (results.length) {
                            results.forEach(function(result) {
                                _this.results.append(_this.renderProperty(result));
                            });
                        }
                        else {
                            _this.results.empty();
                        }
                    },
                    error: function(e) {
                        _this.results.empty();
                    }
                });
            }
        });

        _this.input.focus(function(e) {
            if (window.matchMedia("(max-width: 768px)").matches) {
                $('body').css('overflow', 'hidden');
            }

            _this.container.addClass('focus');
        });

        _this.container.click(function() {
            _this.container.addClass('focus');
            _this.input.focus();
        });

        _this.input.blur(function(e) {
            // Wait a bit before closing the autocomplete, in case the user click on a link
            setTimeout(function() {
                $('body').css('overflow', '');
                _this.container.removeClass('focus');
            }, 200);
        });
    },
    triggerEvent: function(eventName, parameters) {
        var event = $.Event(eventName);

        for(var i in parameters) {
            event[i] = parameters[i];
        }
        
        this.container.trigger(event);
        
        return event;
    },
    renderProperty: function(property) {
        var url = "/listing/" + property.id + '/' + property.full_address.replace(/-/g, '--').replace(/ /g, '-');

        return generatePropertyItem(property, url, {
            cssClass: 'property-block autocomplete-item'
        });
    }
};

/* Create the jQuery functions to be able to apply the autocomplete events easily after creation */
$.fn.onEnter = function(fct) { $(this).bind('onEnter', fct); }
$.fn.onSelectItem = function(fct) { $(this).bind('onSelectItem', fct); }

$.fn.autocomplete = function (options) {
    var autocomplete = new Autocomplete($(this) ,options);
    $(this).data('autocomplete', autocomplete);
    return autocomplete;
}